import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Hero = () => {
  const { ref, inView } = useScrollAnimation({ threshold: 0.3 });

  const appStoreUrl = "https://apps.apple.com/ng/app/nisa-care/id6767461961";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.project.nisacare";

  return (
    <section id="home" className="hero-section">
      <Container>
        <Row className="align-items-center g-4">
          <Col lg={7} className="hero-content">
            <div
              ref={ref}
              className={`animate-on-scroll ${inView ? 'visible' : ''}`}
            >
              <div className="hero-trust-badge">
                <span className="trust-dot"></span>
                <span>Trusted by thousands of Muslim women worldwide</span>
              </div>

              <h1 className="hero-title">
                Rooted in faith,<br />
                <span className="highlight">Designed for a lifetime of wellness</span>
              </h1>

              <p className="hero-description">
                The only app that harmonizes your menstrual cycle, prayer times, 
                and spiritual wellness — all in one beautiful, private space.
              </p>

<div class="hero-buttons">
  <a 
    href="https://apps.apple.com/ng/app/nisa-care/id6767461961" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="app-store-badge"
    aria-label="Download on the App Store"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="22" width="22" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
      <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"></path>
    </svg>
    <span>
      <small>Download on the</small>
      <strong>App Store</strong>
    </span>
  </a>
  <a 
    href="https://play.google.com/store/apps/details?id=com.project.nisacare" 
    target="_blank" 
    rel="noopener noreferrer" 
    class="play-store-badge"
    aria-label="Get it on Google Play"
  >
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="22" width="22" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27"></path>
    </svg>
    <span>
      <small>Get it on</small>
      <strong>Google Play</strong>
    </span>
  </a>
</div>

              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">50K+</span>
                  <span className="stat-label">Downloads</span>
                </div>
                <span className="stat-divider"></span>
                <div className="stat-item">
                  <span className="stat-number">4.8★</span>
                  <span className="stat-label">App Store Rating</span>
                </div>
                <span className="stat-divider"></span>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <span className="stat-label">Private & Secure</span>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={5} className="hero-phone">
            <div className={`phone-mockup-container animate-on-scroll scale-in ${inView ? 'visible' : ''}`}>
              <div className="phone-frame">
                <img
                  src="/images/screenshots/screenshot-1.png"
                  alt="Nisa Care App - Cycle Tracking Dashboard"
                  className="phone-image"
                  loading="lazy"
                />
              </div>
              <div className="floating-cards">
                <div className="float-card card-1">
                  <div className="float-icon">
                    <img src="/icons/prayer-times.svg" alt="Prayer Times" />
                  </div>
                  <span>Prayer Times</span>
                </div>
                <div className="float-card card-2">
                  <div className="float-icon">
                    <img src="/icons/cycle-tracking.svg" alt="Cycle Tracking" />
                  </div>
                  <span>Cycle Tracking</span>
                </div>
                <div className="float-card card-3">
                  <div className="float-icon">
                    <img src="/icons/dua-quran.svg" alt="Dua & Quran" />
                  </div>
                  <span>Dua & Quran</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;